import React from "react";

const ProjectList = ({ detail }) => {
  return (
    <div className="card project-card border-0 rounded-4 mb-5">
      <div className="card-body p-5">
        <div className="row g-5 align-items-start">
          <div className="col-lg-5">
            <div className="project-left">
              <h4 className="fw-bold project-title">{detail.title}</h4>

              <span className="project-category">{detail.category}</span>

              <div className="tech-stack">
                {detail.tech.map((item) => (
                  <span key={item} className="tech-badge">
                    {item}
                  </span>
                ))}
              </div>

              {detail.website && (
                <a
                  href={detail.website}
                  target="_blank"
                  rel="noreferrer"
                  className="portfolio-link"
                >
                  Visit Website →
                </a>
              )}
            </div>
          </div>

          <div className="col-lg-7">
            <div className="project-right">
              <p className="project-description">{detail.description}</p>

              <h6 className="contribution-title">Key Contributions</h6>

              <ul className="project-list">
                {detail.contributions.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectList;
